import type { LeaderboardAudience } from '@/app/[locale]/leaderboard/components/FansClubsToggle'

type LeaderboardQuery = {
  audience?: LeaderboardAudience
  sport?: string
}

export function buildLeaderboardPath({
  audience = 'fans',
  sport = 'all'
}: LeaderboardQuery = {}): string {
  const params = new URLSearchParams()
  if (audience === 'clubs' || audience === 'athletes') {
    params.set('audience', audience)
  }
  // Always keep sport in the query. Bare `/leaderboard` collides with the
  // header Link prefetch cache after a hard reload on a sport-filtered URL,
  // which leaves client tab clicks as no-op router.replace calls.
  params.set('sport', sport === 'all' ? 'all' : sport)
  return `/leaderboard?${params.toString()}`
}

export function readLeaderboardSportFromUrl(
  raw: string | null | undefined
): string {
  const value = raw?.trim()
  if (!value || value.toLowerCase() === 'all') return 'all'
  return value.toUpperCase()
}
